module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioSegundoExamenReg1FIS3.06cd21b3.pdf";